<style scoped>
    .title{
        font-size: 20px;
        font-weight: bold;
        padding: 10px;
        border-bottom: 1px solid #dddee1;
        margin-bottom: 10px;
    }
    .card{
        display: inline-block;
        width: 300px;
        padding: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #dddee1;
        text-align: left;
    }
    .card-title{
        font-weight: bold;
    }
    .card-btn{
        float: right;
        cursor: pointer;
    }
    .card-btn:hover{
        color: #2b62e4;
    }
    .card-name{
        margin-top: 10px;
        border-top: 1px solid #dddee1;
        padding-top: 10px;
    }
</style>
<template>
  <div class="text-center">
    <div class="title">
      服务列表
      <Button
        type="primary"
        icon="md-add"
        @click="editService(new_service)"
      >
        添加
      </Button>
    </div>
    <div class="card-container">
      <div
        v-for="service in services"
        :key="service.id"
        class="card"
      >
        <span class="card-title">
          <Icon type="ios-people-outline" />
          {{ service.title }}
        </span>
        <span
          class="card-btn color-info"
          @click.prevent="editService(service)"
        >
          <Icon type="md-create" />
          编辑
        </span>
        <div class="card-name">
          {{ service.name }}
          <div class="line">
            {{ service.desc || '-' }}
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="edit_modal"
      :loading="edit_loading"
      title="编辑/新增 服务"
      @on-ok="editOk"
    >
      <Form
        ref="service_form"
        :model="edit_service"
        :rules="service_rules"
      >
        <Form-item
          label="名称"
          prop="title"
        >
          <Input
            v-model="edit_service.title"
            placeholder="名称"
          />
        </Form-item>
        <Form-item
          label="模块名"
          prop="name"
        >
          <Input
            v-model="edit_service.name"
            placeholder="模块名"
          />
        </Form-item>
        <Form-item
          label="描述"
          prop="desc"
        >
          <i-input
            v-model="edit_service.desc"
            type="textarea"
            :autosize="{minRows: 2,maxRows: 5}"
            placeholder="请输入..."
          />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script route="/auth/service">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/auth/service',
    /* router_info_end */
    data() {
      return {
        services: [],
        edit_modal: false,
        edit_loading: true,
        new_service: {
          title: '',
          name: '',
          desc: '',
        },
        edit_service: {},
        service_rules: {
          title: [
            { required: true, message: '名称不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '模块名不能为空', trigger: 'blur' }
          ],
        }
      }
    },
    computed: {

    },
    created() {
      this.getServices();
    },
    mounted() {
      //
    },
    methods: {
      getServices() {
        console.log('Util.api.get_groups', Util.api.get_groups)
        Util.ajax.get(Util.api.get_services, {
          //
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.services = [];
          data.forEach((service) => {
            this.services.push(service);
          })
        }).catch((e) => {
          console.log(e);
        });
      },
      editService(service) {
        this.edit_modal = true;
        if (service.id) {
          this.edit_service = Util.clone(service);
        } else {
          this.edit_service = service;
        }
      },
      editOk() {
        this.$refs['service_form'].validate((valid) => {
          if (valid) {
            console.log('Util.api.get_groups', Util.api.get_groups)
            Util.ajax.post(Util.api.service_update, this.edit_service).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              if (data.code === 1) {
                this.edit_modal = false;
                this.insertOrUpdateService(data.service);
                this.$Message.success({
                  content: '操作成功!'
                });
              } else {
                this.edit_loading = false;
                setTimeout(() => {
                  this.edit_loading = true;
                }, 500);
                this.$Modal.error({
                  title: '提示',
                  content: data.msg
                })
              }
            }).catch((e) => {
              this.edit_loading = false;
              setTimeout(() => {
                this.edit_loading = true;
              }, 500);
              console.log(e);
              this.$Message.error({
                content: '操作失败!'
              });
            });
          } else {
            this.$Message.error('表单验证失败!');
            this.edit_loading = false;
            setTimeout(() => {
              this.edit_loading = true;
            }, 500);
          }
        })
      },
      insertOrUpdateService(service) {
        const len = this.services.length;
        let exsit = false;
        let cur;
        let index = -1;
        for (let i = 0; i < len; i++) {
          cur = this.services[i];
          if (cur.id === service.id) {
            Object.assign(cur, service);
            exsit = true;
            index = i;
            break;
          }
        }
        if (!exsit) {
          this.services.push(service);
        }
      }
    }
  }
</script>
